import * as actionTypes from '@actions/actionTypes';

/**
 * FLAG (out of scope): `sets` and `dataSet` duplicate `data` in state.
 * They could be derived via memoized selectors (e.g. reselect) from `data` + `index`.
 * Refactor risk: HIGH if UI consumers exist; LOW today — this reducer appears unused
 * (no PAGINATOR_* dispatchers; Table.jsx handles pagination/sorting). Track as follow-up.
 */

const DEFAULT_PAGE_LIMIT = 15;
const SORT_ASC = 'ascending';
const SORT_DESC = 'descending';

const initialState = {
    data: [],
    sets: [],
    dataSet: [],
    index: 0,
    sortColumn: null,
    sortDirection: null,
};

const buildSets = (data) => {
    const sets = [];
    const chunks = data.length / DEFAULT_PAGE_LIMIT;

    for (let i = 0, j = 0; i < chunks; i++, j += DEFAULT_PAGE_LIMIT) {
        sets[i] = data.slice(j, j + DEFAULT_PAGE_LIMIT);
    }

    return sets;
};

const compareValues = (aValue, bValue) => {
    if (!isNaN(parseFloat(aValue)) && !isNaN(parseFloat(bValue))) {
        return parseFloat(aValue) - parseFloat(bValue);
    }

    const aName = aValue.name.toLowerCase();
    const bName = bValue.name.toLowerCase();

    if (aName > bName) {
        return 1;
    }

    if (aName < bName) {
        return -1;
    }

    return 0;
};

const paginator = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PAGINATOR_PAGINATE: {
            const data = action.data ? action.data : state.data;
            const sets = buildSets(data);

            return {
                ...state,
                data: data,
                sets: sets,
                dataSet: sets[state.index],
            };
        }

        case actionTypes.PAGINATOR_CHANGE_PAGE: {
            if (action.index === state.index) {
                return state;
            }

            return {
                ...state,
                index: action.index,
                dataSet: state.sets[action.index],
            };
        }

        case actionTypes.PAGINATOR_SORT: {
            const column = action.column;
            const direction = state.sortColumn === column && state.sortDirection === SORT_ASC
                ? SORT_DESC
                : SORT_ASC;

            const chunks = [].concat(...state.sets);
            const mapped = chunks.map((el, i) => (
                {index: i, value: el[column]}
            ));

            mapped.sort((a, b) => {
                const comparison = compareValues(a.value, b.value);

                return direction === SORT_DESC ? -comparison : comparison;
            });

            const sortedData = mapped.map((el) => chunks[el.index]);
            const sets = buildSets(sortedData);

            return {
                ...state,
                data: sortedData,
                sets: sets,
                dataSet: sets[state.index],
                sortColumn: column,
                sortDirection: direction,
            };
        }

        default:
            return state;
    }
};

export default paginator;
